(function secureSr1AccessPage(document) {
  'use strict';

  var root = document.querySelector('[data-sr1-access]');
  if (!root || !window.CAP_SR1) return;

  var emailForm = root.querySelector('[data-sr1-email-form]');
  var otpForm = root.querySelector('[data-sr1-otp-form]');
  var emailInput = root.querySelector('[data-sr1-email]');
  var otpInput = root.querySelector('[data-sr1-otp]');
  var status = root.querySelector('[data-sr1-status]');
  var resend = root.querySelector('[data-sr1-resend]');
  var changeEmail = root.querySelector('[data-sr1-change-email]');
  var logout = root.querySelector('[data-sr1-logout]');
  var verifiedName = root.querySelector('[data-sr1-verified-name]');
  var verifiedEmail = root.querySelector('[data-sr1-verified-email]');
  var countdownTimer = 0;
  var pendingEmail = '';

  function message(text, tone) {
    status.textContent = text || '';
    status.dataset.tone = tone || 'neutral';
  }

  function busy(form, active) {
    form.setAttribute('aria-busy', active ? 'true' : 'false');
    Array.prototype.forEach.call(form.querySelectorAll('button, input'), function (field) {
      field.disabled = Boolean(active);
    });
  }

  function showStep(step) {
    root.dataset.step = step;
    Array.prototype.forEach.call(root.querySelectorAll('[data-sr1-step]'), function (item) {
      var active = item.dataset.sr1Step === step;
      item.classList.toggle('is-current', active);
      if (active) item.setAttribute('aria-current', 'step');
      else item.removeAttribute('aria-current');
    });
  }

  function startCountdown(seconds) {
    window.clearInterval(countdownTimer);
    var remaining = seconds;
    resend.disabled = true;
    resend.textContent = 'Resend in ' + remaining + 's';
    countdownTimer = window.setInterval(function () {
      remaining -= 1;
      resend.textContent = remaining > 0 ? 'Resend in ' + remaining + 's' : 'Send a new code';
      if (remaining <= 0) {
        window.clearInterval(countdownTimer);
        resend.disabled = false;
      }
    }, 1000);
  }

  function renderState(detail) {
    if (detail && detail.authorized && detail.rep) {
      showStep('granted');
      verifiedName.textContent = detail.rep.display_name || 'Sales Rep';
      verifiedEmail.textContent = detail.rep.normalized_email || detail.rep.email || '';
      message('Identity and active status verified securely.', 'success');
      return;
    }
    if (root.dataset.step === 'granted') showStep('email');
  }

  emailForm.addEventListener('submit', async function (event) {
    event.preventDefault();
    var email = String(emailInput.value || '').trim().toLowerCase();
    if (!emailInput.checkValidity()) {
      emailInput.reportValidity();
      return;
    }
    busy(emailForm, true);
    message('Checking the secure directory...', 'loading');
    try {
      await window.CAP_SR1.startOtp(email);
      pendingEmail = email;
      showStep('otp');
      otpInput.disabled = false;
      message('If this email is eligible, a one-time code is on its way.', 'success');
      startCountdown(45);
      window.setTimeout(function () { otpInput.focus(); }, 50);
    } catch (error) {
      message(error.message || 'Secure sign-in is temporarily unavailable.', 'error');
    } finally {
      busy(emailForm, false);
    }
  });

  otpForm.addEventListener('submit', async function (event) {
    event.preventDefault();
    var code = String(otpInput.value || '').replace(/\D/g, '');
    if (!pendingEmail || code.length < 6) {
      message('Enter the complete numeric code from your email.', 'error');
      otpInput.focus();
      return;
    }
    busy(otpForm, true);
    message('Verifying your code and current Sales Rep status...', 'loading');
    try {
      var result = await window.CAP_SR1.verifyOtp(pendingEmail, code);
      renderState(result);
    } catch (error) {
      otpInput.value = '';
      message(error.message || 'That code could not be verified.', 'error');
      otpInput.focus();
    } finally {
      busy(otpForm, false);
    }
  });

  otpInput.addEventListener('input', function () {
    otpInput.value = otpInput.value.replace(/\D/g, '').slice(0, 8);
  });

  resend.addEventListener('click', async function () {
    if (!pendingEmail || resend.disabled) return;
    resend.disabled = true;
    message('Requesting a new code...', 'loading');
    try {
      await window.CAP_SR1.startOtp(pendingEmail);
      message('If this email is eligible, a new code is on its way.', 'success');
      startCountdown(45);
    } catch (error) {
      resend.disabled = false;
      message(error.message || 'A new code could not be requested.', 'error');
    }
  });

  changeEmail.addEventListener('click', function () {
    window.clearInterval(countdownTimer);
    pendingEmail = '';
    otpInput.value = '';
    otpInput.disabled = true;
    showStep('email');
    message('', 'neutral');
    emailInput.focus();
  });

  logout.addEventListener('click', async function () {
    logout.disabled = true;
    message('Closing your secure session...', 'loading');
    await window.CAP_SR1.logout();
    pendingEmail = '';
    otpInput.value = '';
    otpInput.disabled = true;
    showStep('email');
    message('You have been signed out.', 'success');
    logout.disabled = false;
    emailInput.focus();
  });

  document.addEventListener('cap:sr1-state', function (event) { renderState(event.detail); });
  window.CAP_SR1.ready.then(renderState);
})(document);

